(function ($) {
  $.fn.extend({
    center: function (options) {
      var options = $.extend(
        {
          duration: 500,
          callback: null,
          animate: false,
        },
        options || {}
      );

      return this.each(function () {
        var top =
          $(window).scrollTop() +
          ($(window).height() - $(this).outerHeight()) / 2;
        var left = ($(window).width() - $(this).outerWidth()) / 2;
        var o = {
          position: "absolute",
          margin: 0,
          top: (top > 0 ? top : 0) + "px",
          left: (left > 0 ? left : 0) + "px",
        };
        if (options.animate) {
          $(this).animate(o, options.duration, options.callback);
        } else {
          $(this).css(o);
        }
      });
    },
  });
})(jQuery);

(function ($) {
  $.fn.extend({
    center_fixed: function (options) {
      var options = $.extend(
        {
          duration: 500,
          callback: null,
          animate: false,
        },
        options || {}
      );

      return this.each(function () {
        var top = ($(window).height() - $(this).outerHeight()) / 2;
        var left = ($(window).width() - $(this).outerWidth()) / 2;
        var o = {
          position: "fixed",
          margin: 0,
          top: (top > 0 ? top : 0) + "px",
          left: (left > 0 ? left : 0) + "px",
        };
        if (options.animate) {
          $(this).animate(o, options.duration, options.callback);
        } else {
          $(this).css(o);
        }
      });
    },
  });
})(jQuery);

(function ($) {
  $.fn.cloneOffset = function (element, options) {
    var options = $.extend(
      {
        setLeft: true,
        setTop: true,
        setWidth: false,
        setHeight: false,
        offsetLeft: 0,
        offsetTop: 0,
      },
      options || {}
    );

    var el = $(this); //what to position
    var src = $(element); //where to position
    var o = src.offset();
    var x = o.left + options.offsetLeft;
    var y = o.top + options.offsetTop;

    el.offset({ left: x, top: y });

    return el;
  };
})(jQuery);

jQuery.extend({
  getQueryParameters: function (str) {
    return (str || document.location.search)
      .replace(/(^\?)/, "")
      .split("&")
      .map(
        function (n) {
          return (n = n.split("=")), (this[n[0]] = n[1]), this;
        }.bind({})
      )[0];
  },
});

$.isBlank = (object) =>
  ($.isPlainObject(object) && $.isEmptyObject(object)) ||
  ($.isArray(object) && object.length == 0) ||
  (typeof object === "string" && $.trim(object) === "") ||
  !object;

$.fn.positionOn = function positionOn(element, options) {
  function positionOnF() {
    const target = $(this); // element to move
    const position = element.offset();

    let x = position.left;
    const y = position.top;

    const offsetLeft = options.offsetLeft || 0;
    const offsetTop = options.offsetTop || 0;

    const align = options.align;

    if (align == "right") {
      x -= target.outerWidth() - element.outerWidth();
    } else if (align == "center") {
      x -= target.outerWidth() / 2 - element.outerWidth() / 2;
    }

    target.css({
      position: "absolute",
      zIndex: 10001,
      top: `${y + offsetTop}px`,
      left: `${x + offsetLeft}px`,
    });
  }
  return this.each(positionOnF);
};

(function ($) {
  const re = /([^&=]+)=?([^&]*)/g;
  const decodeRE = /\+/g; // Regex for replacing addition symbol with a space
  const decode = function (str) {
    return decodeURIComponent(str.replace(decodeRE, " "));
  };
  $.parseParams = function (query) {
    const params = {};

    let e;
    while ((e = re.exec(query))) {
      let k = decode(e[1]);

      const v = decode(e[2]);
      if (k.substring(k.length - 2) === "[]") {
        k = k.substring(0, k.length - 2);
        (params[k] || (params[k] = [])).push(v);
      } else params[k] = v;
    }
    return params;
  };
})(jQuery);

(function (plugin) {
  // AMD Support
  if (typeof define === "function" && define.amd) {
    define(["jquery"], plugin);
  } else {
    plugin(jQuery);
  }
})(function ($) {
  $.QueryString = (function (a) {
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
      var p = a[i].split("=");
      if (p.length != 2) continue;
      b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
  })(window.location.search.substr(1).split("&"));
});

$.cachedScript = function (url, options) {
  // Allow user to set any option except for dataType, cache, and url
  options = $.extend(options || {}, {
    dataType: "script",
    cache: true,
    url: url,
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return $.ajax(options);
};

// Usage
// $.cachedScript( "ajax/test.js" ).done(function( script, textStatus ) {
//   console.log( textStatus );
// });
